import {
  ScheduleOutlined as RecentIcon,
  ThumbUpOutlined as LikedIcon,
  TrendingUpOutlined as UsageIcon,
  HistoryOutlined as LastUsedIcon,
  UpdateOutlined as UpdatedIcon,
  SortByAlphaOutlined as AlphaIcon,
  AutoAwesomeOutlined as PopularIcon,
  FavoriteBorderOutlined as FavoritesIcon,
} from '@mui/icons-material';

const SORT_KEY_ICONS = {
  recent: RecentIcon,
  popular: PopularIcon,
  usage: UsageIcon,
  lastUsed: LastUsedIcon,
  updated: UpdatedIcon,
  title: AlphaIcon,
  name: AlphaIcon,
  likes: LikedIcon,
  favorites: FavoritesIcon,
};

export function getSortOptionIcon(option) {
  if (option?.icon) return option.icon;
  return SORT_KEY_ICONS[option?.key] || RecentIcon;
}

export function isAlphabeticalSortKey(key) {
  return key === 'name' || key === 'title';
}
